export const BRAND_KEY = 'kenwood'
export const BRAND_LABEL = 'Kenwood'
export const BRAND_SHORT_LABEL = 'KW'
export const BRAND_CODE_MARKETING_CLOUD = 'ken'
export const BRAND_INFO = {
    key: BRAND_KEY,
    label: BRAND_LABEL,
}
export const BRAND_KEY_FILTER_CS = BRAND_KEY
export const MAIN_DOMAIN = 'kenwoodworld.com'
